import { Btn } from './CalendarBtn.styled';

const CalendarIcon = () => {
  return (
    <svg viewBox="0 0 19 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 9H12V11H14V9Z" />
      <path d="M10 9H8V11H10V9Z" />
      <path d="M6.00002 9H4V11H6.00002V9Z" />
      <path d="M16 2.00001H15V0H13V2.00001H5.00001V0H3V2.00001H2.00001C0.890015 2.00001 0.0100313 2.90001 0.0100313 4.00003L0 18C0 19.1 0.890015 20 2.00001 20H16C17.1 20 18 19.1 18 18V3.99998C18 2.90001 17.1 2.00001 16 2.00001ZM16 18H2.00001V6.99998H16V18Z" />
    </svg>
  );
};

const accentColor = '#FC842D';

const CloseIcon = () => {
  return (
    <svg
      viewBox="0 0 30 32"
      fill={accentColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z" />
    </svg>
  );
};

export const CalendarBtn = ({ onHandleClick, isShown }) => {
  return (
    <Btn onClick={() => onHandleClick()}>
      {isShown ? <CloseIcon /> : <CalendarIcon />}
    </Btn>
  );
};
